// extracted by mini-css-extract-plugin
export default {"pageContainer":"ArtistAlbumSearch_pageContainer__xcU1p"};